import { identity, delay as postpone } from 'lodash';

/**
 * Returns a promise that will be resolved with value (or undefined) after given
 * ms milliseconds. If value is a promise, the delay will start counting down
 * when it is fulfilled and the returned promise will be fulfilled with the
 * fulfillment value of the value promise. If value is a rejected promise,
 * the resulting promise will be rejected immediately.
 * @param {number} ms to delay
 * @param {any} [value]
 */
export function delay(ms = 0, value) {
	return Promise.resolve(value).then(
		// eslint-disable-next-line lodash-fp/no-extraneous-args
		(result) => new Promise((resolve) => postpone(resolve, ms, result))
	);
}

/**
 * Polyfill for obsolete Promise.defer() method
 */
export function getDeferred() {
	return (() => {
		let resolve;
		let reject;

		const p = new Promise((res, rej) => {
			resolve = res;
			reject = rej;
		});

		return {
			promise: p,
			reject,
			resolve,
		};
	})();
}

/**
 * Convert rejection to fulfillment. Useful for Promise.all which should not be interrupted.
 * Works like Promise.allSettled, which we could not use until corejs3 lands into gatsby.
 */
export const preventPromiseRejection = (promise) => Promise.resolve(promise).catch(identity);
